import gql from 'graphql-tag';

export const fetchCompanyQuery = gql`
  query fetchCompany($companyId: String!) {
    fetch_company(input: { company_id: $companyId }) {
      company_id
      name
      address_line_1
      address_line_2
      city
      state
      country
      post_code
      contact {
        type
        value
        display
        display_order
        is_primary
      }
      status
      registration_id
      tax_id
      tax {
        type
        value
      }
      bank_detail {
        account_name
        account_number
        bank_name
        branch_name
        ifsc_code
        payment_method
      }
      kravein_configuration {
        auto_send_invoice
        invoice_cycle
        invoice_email
      }
      places {
        place_id
        name
        city
        state
        status
        address_line_1
      }
      audit {
        created_at
        updated_at
      }
      error {
        code
        description
      }
    }
  }
`;

export const createCompanyMutation = gql`
  mutation createCompany($input: CompanyInput) {
    create_company(input: $input) {
      company_id
      name
      error {
        description
      }
    }
  }
`;

export const updateCompanyMutation = gql`
  mutation updateCompany($input: CompanyInput) {
    update_company(input: $input) {
      company_id
      name
      error {
        code
        description
      }
    }
  }
`;

export const searchCompanyLinkedPlacesQuery = gql`
  query searchCompanyLinkedPlaces($input: SearchInput) {
    search_companies(input: $input) {
      company_listing {
        company_id
        places {
          place_id
          name
          city
          address_line_1
        }
      }
    }
  }
`;

export const linkPlaceMutation = gql`
  mutation linkPlace($input: PlaceInput) {
    update_place(input: $input) {
      place_id
      name
      error {
        code
        description
      }
    }
  }
`;

export const companySummaryQuery = gql`
  query companySummary($input: SearchInput) {
    company_summary(input: $input) {
      total_companies
      places_linked
      abn_count
      bank_details_count
      error {
        code
        description
      }
    }
  }
`;

export const searchCompaniesQuery = gql`
  query searchCompanies($input: SearchInput) {
    search_companies(input: $input) {
      total_pages
      total_size
      company_listing {
        company_id
        name
        city
        state
        country
        post_code
        abn
        abn_status
        bank_status
        address_line_1
        status
        counts
        contact {
          type
          value
          is_primary
          display
        }
        places {
          place_id
          name
          city
          state
          status
          address_line_1
          address_line_2
        }
        audit {
          created_at
          updated_at
        }
      }
      error {
        code
        description
      }
    }
  }
`;
